const checkClickInside = (event, classMarker) => {
  let target = event.target;
  let isClickInside = false;
  while (target.parentElement && !isClickInside) {
    if (target.classList.contains(classMarker)) isClickInside = true;
    target = target.parentElement;
  }
  return isClickInside;
}

export default checkClickInside;


// WEBPACK FOOTER //
// ./src/utils/checkClickInside.js